module.exports = __webpack_public_path__ + "img/background.b9cdd3fb.png";